import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop, Rect, G, ClipPath } from "react-native-svg";

export default function AnimationIcon(props) {
  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_animation)">
          <Path
            d="M14.7289 5.9446L16.9788 12.8658L20.2591 15.2925C20.562 15.483 20.8243 15.7313 21.0312 16.0233C21.238 16.3152 21.3853 16.645 21.4647 16.9939C21.544 17.3428 21.5539 17.7039 21.4937 18.0566C21.4334 18.4093 21.3043 18.7467 21.1136 19.0495L20.63 19.8182C20.3729 20.2252 19.9649 20.5137 19.4955 20.6206C19.0261 20.7275 18.5334 20.644 18.1254 20.3885L3.31405 10.7035C2.9068 10.4463 2.6181 10.0382 2.51121 9.56853C2.40432 9.09888 2.48795 8.60602 2.74378 8.19793L6.21045 2.68766C6.57878 2.1018 7.57978 2.068 7.77045 2.73273C7.97617 3.39735 8.31903 4.01141 8.77689 4.53525C9.23474 5.05909 9.7974 5.48105 10.4285 5.77386C11.801 6.31746 13.3176 6.37767 14.7289 5.9446V5.9446Z"
            fill="url(#paint0_linear_animation)"
          />
          <Path
            d="M11.9996 18.9326H1.59961V20.666H11.9996V18.9326Z"
            fill="url(#paint1_linear_animation)"
          />
          <Path
            d="M5.93294 14.5996H1.59961V16.3329H5.93294V14.5996Z"
            fill="url(#paint2_linear_animation)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_animation"
            x1="2.46582"
            y1="6.23696"
            x2="11.1475"
            y2="24.5943"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_animation"
            x1="1.59961"
            y1="19.3085"
            x2="1.77084"
            y2="21.4078"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_animation"
            x1="1.59961"
            y1="14.9755"
            x2="1.99803"
            y2="17.0108"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <ClipPath id="clip0_animation">
            <Rect
              width="20.8"
              height="20.8"
              fill="white"
              transform="translate(1.59961 1.59961)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
